<script>
  import Modal from '@components/general/modal.svelte'
  import Table from '@components/table'
  import BoxedText from '@components/general/boxed-text.svelte'
  import { formatDate } from '@lib/utils/date'

  let { open = $bindable(false), memberships = [] } = $props()

  let statusVariant = { active: 'success', inactive: 'default', canceled: 'error' }
</script>

<Modal title="Programme Members" bind:open width="60rem" avoidFocus>
  <Table.Root empty={memberships.length === 0} emptyMessage="No members yet">
    <Table.Head>
      <Table.Header width="25%">Name</Table.Header>
      <Table.Header width="30%">Email</Table.Header>
      <Table.Header width="15%">Offer</Table.Header>
      <Table.Header width="15%" align="center">Status</Table.Header>
      <Table.Header width="15%" align="center">Joined</Table.Header>
    </Table.Head>
    <Table.Body>
      {#each memberships as membership (membership.id)}
        <Table.Row>
          <Table.Cell width="25%">{membership.user.name}</Table.Cell>
          <Table.Cell width="30%">{membership.user.email_address}</Table.Cell>
          <Table.Cell width="15%">{membership.offer?.name || '—'}</Table.Cell>
          <Table.Cell width="15%" align="center">
            <BoxedText variant={statusVariant[membership.status]} size="xs" text={membership.status} />
          </Table.Cell>
          <Table.Cell width="15%" align="center">{formatDate(membership.created_at)}</Table.Cell>
        </Table.Row>
      {/each}
    </Table.Body>
  </Table.Root>
</Modal>
